import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import "../Assets/css/layout.css";
import Profile from "../Assets/Img/Profile.png";
import notification from "../Assets/Img/notification.png";
import axiosMain from "../http/axiosMain";
import Notifications from "../Main/Notification";
import { GlobalContext } from "../../utils/GlobalContext";

function Navbar() {
  const today = new Date();
  // const { userData } = useContext(GlobalContext);
  const { userData, setUserData } = useContext(GlobalContext);
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const [ProfilePicture, setProfilePicture] = useState();

  // Dhruv Rajpurohit
  useEffect(() => {
    const fetchBrandProfile = async () => {
      try {
        const response = await axiosMain.get("/api/v1/get-brand-profile");
        console.log("API Response:", response.data);

        // Ensure the value exists before setting it
        if (response.data?.user?.user_photo) {
          setProfilePicture(response.data.user.user_photo);
        } else {
          console.warn("Profile picture not found in API response.");
        }
      } catch (error) {
        console.error("Error fetching brand profile:", error);
      }
    };

    fetchBrandProfile(); // Call the function inside useEffect
  }, []); // Empty dependency array to run only once

  // Dhruv Rajpurohit
  const handleNotificationClick = () => {
    localStorage.setItem("previousPage", location.pathname);
  };

  const options = { weekday: "long", day: "numeric", month: "short" };
  const formattedDate = today.toLocaleDateString("en-US", options);

  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);

  const pageTitles = {
    "/": "Home",
    "/brand-home": "Home",
    "/payment": "Payment",
    "/message": "Message",
    "/notifications": "Notifications",
    "/myprofile": "My Profile",
    "/settings": "Settings",
    "/messages/chat": "Chat",
    "/campaign": "Campaign",
    "/insights": "Insights",
    // "/campaign-create": "campaign-create",
    // Dhruv Rajpurohit
    "/campaign-create": "Campaign",
    "/influencerstats": "Statistics",
  };

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const mainPage = `/${pathSegments[0] || ""}`;
  const childPage =
    pathSegments.length > 1 ? `/${pathSegments.join("/")}` : null;

  const mainTitle = pageTitles[mainPage] || "Navbar";
  const childTitle =
    childPage && pageTitles[childPage] ? ` / ${pageTitles[childPage]}` : "";

  const confirmLogout = async () => {
    try {
      const response = await axiosMain.get(
        "/api/v1/logout",
        {},
        { withCredentials: true } // Ensures cookies are sent with the request
      );
      console.log(response);

      if (response.status === 200) {
        localStorage.clear();
        window.location.reload();
        // navigate("/");
      }
    } catch (error) {
      console.error("Logout error:", error);
      console.log("Logout failed. Please try again.");
    } finally {
      setShowLogoutModal(false);
    }
  };
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container-fluid">
        <h3 className="navbar-brand">
          {mainTitle}
          <span className="child-page">{childTitle}</span>
        </h3>

        <div className="collapse navbar-collapse justify-content-end">
          <form className="d-flex align-items-center">
            <h6 className="nav-date">{formattedDate}</h6>

            {/* <Link to="/notifications" onClick={handleNotificationClick}>
              <div className="NavbarNotificationImage">
                <img src={notification} className="img-fluid" alt="New Icon" />
              </div>
            </Link> */}
            {/* Notification Icon */}
            <div
              onClick={() => setShowNotifications(true)}
              style={{ cursor: "pointer" }}
            >
              <div className="NavbarNotificationImage">
                <img
                  src={notification}
                  className="img-fluid"
                  alt="Notifications"
                />
              </div>
            </div>
            {/* Notifications Modal */}
            <Modal
              show={showNotifications}
              onHide={() => setShowNotifications(false)}
              centered
              size="lg"
            >
              <Modal.Body>
                <Notifications onClose={() => setShowNotifications(false)} />
              </Modal.Body>
            </Modal>

            <div className="ProfileIcon" ref={dropdownRef}>
              {/* Profile Icon to Toggle Dropdown */}
              {/* <div onClick={() => setShowDropdown(!showDropdown)}>
                <img
                  src={userData?.user_photo || Profile}
                  className="img-fluid"
                  alt="Profile Icon"
                />
              </div> */}
              <div onClick={() => setShowDropdown(!showDropdown)}>
                <img
                  src={userData?.user_photo || Profile}
                  className="img-fluid"
                  alt="Profile Icon"
                  style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                />
              </div>

              {/* Dropdown Menu */}
              {showDropdown && (
                <div className="user-dropdown-menu">
                  <ul>
                    <li className="profile-nav"
                      onClick={() => {
                        setShowDropdown(false);
                        navigate("/myprofile");
                      }}
                    >
                      Profile
                    </li>
                    <h5 className="account-design">Account</h5>
                    <li
                    className="setting-nav"
                      onClick={() => {
                        setShowDropdown(false);
                        navigate("/settings");
                      }}
                    >
                      Settings & Privacy
                    </li>
                    <li className="logout-nav"
                      onClick={() => {
                        setShowDropdown(false);
                        setShowLogoutModal(true);
                      }}
                    >
                      Logout
                    </li>
                  </ul>
                </div>
              )}

              {/* Logout Modal */}
              <Modal
                show={showLogoutModal}
                onHide={() => setShowLogoutModal(false)}
                centered
              >
                <Modal.Body className="text-center">
                  <h5>Leaving so soon?</h5>
                  <h5>Don't forget to save your progress before you go!</h5>
                  <div className="mt-4">
                    <Button
                      variant="danger"
                      onClick={confirmLogout}
                      className="me-2"
                      style={{ backgroundColor: "rgba(107, 142, 118, 1)" }}
                    >
                      Logout
                    </Button>
                    <Button
                      variant="btn-secondary"
                      onClick={() => setShowLogoutModal(false)}
                      style={{ border: "1px solid gray" }}
                    >
                      Cancel
                    </Button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </form>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
